export const USER_SERVICE_API_ROOT = '/core/v1/users';
export const USER_LOGS_API_ROOT = '/customer-identity/v1/customer-identity';
